import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from '../Service/api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {
  EMAIL_ID = "";
  PASSWORD = "";
  //supportKey = "";

  passwordVisible = false;
  isloginSpinning = false;
  userId = this.cookie.get('userId');
  userName = this.cookie.get('userName');
  roleId :any = this.cookie.get('roleId');
  isLogedIn = false;

  emailId = "";
  constructor(private router: Router, private api: ApiService, private message: NzNotificationService, private cookie: CookieService) { }

  ngOnInit(): void {
    if (this.cookie.get('token') === '' || this.cookie.get('token') === null) {
      //this.api.logoutForSessionValues();
      this.router.navigate(['/login']);
    }

    else {
      if (this.userId == null || this.userName == null || this.roleId == null)
        this.api.logoutForSessionValues();

      else {
        this.isLogedIn = true;

        if(this.roleId != 10)
        {
          this.router.navigate(['/projects']);

        }else
        {
          this.router.navigate(['/projectsdetails']);


        }
      }
    }
    //const userId = '1';
    //this.api.requestPermission(this.userId)
  }

  login(): void {
    if (this.EMAIL_ID == "" && this.PASSWORD == "")
      this.message.error("Please enter email id and password", "");

    else {
      this.isloginSpinning = true;
      this.api.login(this.EMAIL_ID, this.PASSWORD).subscribe(data => {
       

        if (data['code'] == 200) {
          this.cookie.set('token', data["data"][0]["token"], 365, "", "", false, "Strict");
          this.cookie.set("userId", data["data"][0]['UserData'][0]['USER_ID'], 365, "", "", false, "Strict")
          this.cookie.set("userName", data["data"][0]['UserData'][0]['NAME'], 365, "", "", false, "Strict")
          this.cookie.set("emailId", data["data"][0]['UserData'][0]['EMAIL_ID'], 365, "", "", false, "Strict")
          this.cookie.set("roleId", data["data"][0]['UserData'][0]['ROLE_DETAILS'][0]["ROLE_ID"], 365, "", "", false, "Strict")
          this.cookie.set("level", data["data"][0]['UserData'][0]['ROLE_DETAILS'][0]["LEVEL"], 365, "", "", false, "Strict")
          this.cookie.set("roleName", data["data"][0]['UserData'][0]['ROLE_DETAILS'][0]["ROLE_NAME"], 365, "", "", false, "Strict")

          this.message.info(data['message'], "");
          this.emailId = this.cookie.get("emailId");
          window.location.reload();

          setTimeout(() => {
            this.isloginSpinning = false;
          }, 1000);

          this.api.addLog('L', "Login Successfully ", this.emailId).subscribe(data => {
            

          }, err => {
        

            if (err['ok'] == false)
              this.message.error("Server Not Found", "");
          });

        } else {
          this.message.error(data['message'], "");
          setTimeout(() => {
            this.isloginSpinning = false;
          }, 1000);

          this.api.addLog('A', data['message'] + " " + "Login Failed with EmailId= " + this.EMAIL_ID + " and Password=" + this.PASSWORD, "0").subscribe(data => {
            

          }, err => {
          

            if (err['ok'] == false)
              this.message.error("Server Not Found", "");
          });
        }

      }, err => {
        this.message.error("Server not found", "");
        this.isloginSpinning = false;
      });
    }
  }
}
